// An invoice's notes as the CLIENT reads them — the office's Print view.
//
// The mirror of server/utils/clientNotes.js, which the public page, the
// emailed invoice and its PDF go through. Mark paid, reverse payment and the
// Stripe paths append their own lines ("Marked as paid", a reversal's reason)
// to `invoices.notes`; this screen read the raw column, so the sheet the
// office prints and hands over still carried them (review of #737).
// clientNotesMirror.test.js compares the pattern below with the server's, character
// for character, so the two cannot drift.

export const BOOKKEEPING = /^(?:\u26A0\uFE0F?\s*)?(?:Marked as paid|Payment note: .*|Payment reversed \(.*\): .*|Payment failed on [\d./-]+|Payment (?:of \$[\d,]+(?:\.\d+)? )?received via Stripe(?: Checkout)? on [\d./-]+(?: \(reconciled from .*\))?)$/;

/** `notes` without the payment paths' lines; '' when nothing a client should read is left. */
export function clientNotes(notes) {
  if (notes == null) return '';
  return String(notes)
    .split(/\r?\n/)
    .filter((line) => !BOOKKEEPING.test(String(line).trim()))
    .join('\n')
    .trim();
}
